import React from 'react';
import { FaReply, FaEye, FaBookmark, FaRegBookmark } from 'react-icons/fa';
import { MdDelete, MdReportProblem, MdDeleteForever } from 'react-icons/md';
import { IoIosCreate } from 'react-icons/io';

/**
 * The menu that appears when a message bubble is hovered.
 *
 * One definition for every pane. The group pane used to hand-roll its own
 * absolutely-positioned red panel with inline styles, so it sat off-centre and
 * read nothing like the direct-message menu; both now render this.
 *
 * An action is omitted when its handler is not supplied, so callers express
 * permissions by simply not passing a handler — which is how a broadcast channel
 * drops Reply and Create thread, and how only its admins get Delete for everyone.
 */
const MessageMenu = ({
  onReply,
  onDelete,
  onRetract,
  onReport,
  onViewThread,
  onCreateThread,
  onToggleSave,
  isSaved = false,
}) => (
  <div className="msg-menu">
    {onReply && (
      <button type="button" className="msg-menu-item" onClick={onReply}>
        <FaReply size={15} />
        Reply
      </button>
    )}

    {/* Available to every member, including in a broadcast channel: read-only means
        you cannot post, not that you cannot keep a copy of what was posted. `isSaved`
        comes from the server's `is_saved` on the message, never from local guesswork,
        so the label always matches what a reload would show. */}
    {onToggleSave && (
      <button
        type="button"
        className="msg-menu-item"
        onClick={onToggleSave}
        aria-pressed={isSaved}
        title={isSaved ? 'Remove from your saved messages' : 'Keep this in your saved messages'}
      >
        {isSaved ? <FaBookmark size={14} /> : <FaRegBookmark size={14} />}
        {isSaved ? 'Remove from saved' : 'Save message'}
      </button>
    )}

    {onDelete && (
      <button type="button" className="msg-menu-item is-danger" onClick={onDelete}>
        <MdDelete size={16} />
        Delete
      </button>
    )}

    {onRetract && (
      <button
        type="button"
        className="msg-menu-item is-danger"
        onClick={onRetract}
        title="Removes the message for every member of this channel"
      >
        <MdDeleteForever size={16} />
        Delete for everyone
      </button>
    )}

    {onReport && (
      <button type="button" className="msg-menu-item" onClick={onReport}>
        <MdReportProblem size={16} />
        Report
      </button>
    )}

    {onViewThread && (
      <button type="button" className="msg-menu-item" onClick={onViewThread}>
        <FaEye size={16} />
        View thread
      </button>
    )}

    {onCreateThread && (
      <button type="button" className="msg-menu-item" onClick={onCreateThread}>
        <IoIosCreate size={16} />
        Create thread
      </button>
    )}
  </div>
);

export default MessageMenu;
